export default {
  methods: {
    getZipMask (value) {
      if (value && value.length > 5) {
        return '#####-####'
      } else {
        return '#####'
      }
    }
  }
}
